
import {Options, Vue} from 'vue-class-component';
import {RestService} from "../service/rest.service";
import PaginationComponent from '@/components/pagination/PaginationComponent.vue';

@Options({
    components: {
      PaginationComponent
    }
  })
  export default class EventView extends Vue {

    restService = new RestService('events')
    searchForm: any = {}
    items: any = []
    totalPages = 0

    mounted() {
      this.gets()
    }

    gets(queryString?: any) {
      this.restService.gets(queryString).then((data: any) => {
        this.totalPages = data.totalPages
        this.items = data
      })
    }

    changePage(page: number) {
      this.searchForm.page = page
      this.gets(this.searchForm)
    }
  }
